// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3ThBp","dragIcon":"Choice_dragIcon__AEUFR","left":"Choice_left__1-GUM","input":"Choice_input__BqXbl"};